import { ConfigProvider } from 'antd';

import ruRU from 'antd/locale/ru_RU';
import './lib/date/moment';
import React from 'react';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import './assets/styles/index.css';
import { Notify } from './components/hoc';
import StyledComponentsCompatibility from './components/StyledComponentsCompatibility';
import AppRoutes from './routes/AppRoutes';
import { persistStore, store } from './store';

const App = () => (
  <StyledComponentsCompatibility>
    <Provider store={store}>
      <ConfigProvider locale={ruRU}>
        <Notify>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </Notify>
      </ConfigProvider>
    </Provider>
  </StyledComponentsCompatibility>
);

export { store, persistStore };

export default App;
